const themeConfig = {
	palette: {
		body: {
			contrastText: "#686c7c",
		},
		dark: {
			light: "#858999",
			main: "#686c7c",
			dark: "#3a3e4a",
			contrastText: "#ffffff",
		},
		snackbar: {
			main: "#006691",
		},
		primary: {
			light: "#ffdbce",
			main: "#DE5000",
			dark: "#71361d",
			contrastText: "#ffffff",
		},
		subnav: {
			main: "#fafafa",
			light: "#E8E8E8",
			contrastText: "#686C7C",
		},
		headings: {
			h1: {
				main: "#006691",
			},
			h2: {
				main: "#101d42",
			},
		},
		tab: {
			paper: "#eeeeee",
			main: "#eeeeee",
			contrastText: "#212121",
			hover: "#101d42",
			contrastTextHover: "#ffffff",
		},
	},
	typography: {
		h2: {
			letterSpacing: "-0.01562em",
		},
		h4: {
			fontSize: "2rem",
		},
		h5: {
			fontFamily: "Noto Sans, sans-serif",
		},
		h6: {
			fontFamily: "Noto Sans, sans-serif",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				link: {
					color: "#696C7B",
				},
			},
		},
	},
	cloverleaf: {
		navbar: {
			borderRadius: 0,
		},
		css: `
      #___gatsby .text h2 {
          color: #3d4da1 !important;
      }
      #___gatsby .tools-nav .MuiSvgIcon-root {
        fill: #696C7B !important;
      }
      #___gatsby .title-blog .share-buttons path {
          fill: #686C7C !important;
      }
      #___gatsby .entities-list-grid .variant-h4.excerpt-title {
        font-size: 1.5rem !important;
      }
      #___gatsby .entities-list-grid .variant-overline {
        color: #686c7c !important;
      }
      #___gatsby .table-responsive table>:not(caption)>*>* {
        border-left: none !important;
        border-right: none !important;
        border-color: #696C7B !important;
        border-width: 1px !important;
      }
      #___gatsby .MuiFab-primary {
        background-color: #4498D8 !important;
      }
      #___gatsby .MuiFab-primary:hover {
        background-color: #0F2C3E !important;
      }
      #___gatsby :focus,
      #___gatsby a:focus,
      #___gatsby button:focus {
        outline: 2px solid blue;
      }
      #___gatsby .highlight .MuiTypography-h2 {
        color: #101d42 !important;
      }
    `,
	},
};
module.exports = themeConfig;
